import { useEffect, useState, useLayoutEffect } from "react";
import { Row, Col, Container } from "react-bootstrap";
//import image1 from "./image1.png";
import { Alert } from "react-bootstrap";
import axios from 'axios';
import BeatStarsIcon from "./BeatStarsIcon";

const BEATSTARS_TRACKS_URL = "https://www.beatstars.com/genwav/tracks";

// Beat pack deals shown under the BeatStars catalog embed.
const BEAT_DEALS = [
  { name: "Trap Pack", detail: "5 Trap Beats for $50", url: "https://www.beatstars.com/collection/208968" },
  { name: "Reggaeton Pack", detail: "5 Reggaeton Beats for $50", url: "https://www.beatstars.com/collection/208970" }
];


const API_BASE_URL = `${process.env.REACT_APP_API_BASE_URL || ''}/api`;

const Music = () => {
  useEffect(() => {
    document.title = "Enigma Labs | Music Producer, Recording & Audio Engineer in Miami & Fort Lauderdale";
    document.querySelector('meta[name="description"]')?.setAttribute(
      "content",
      "Music producer, reggaeton & Latin music producer, recording engineer and audio engineer in Miami & Fort Lauderdale — recording sessions, mixing & mastering, songwriting, beats and music lessons for artists across South Florida, from Kendall and Little Havana to Davie, Sunrise and up to Tampa & Orlando."
    );
  }, []);

  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [beats, setBeats] = useState(false);
  const [mixing, setMixing] = useState(false);
  const [loopsTemplates, setLoopsTemplates] = useState(false);
  const [visuals, setVisuals] = useState(false);
  const [web, setWeb] = useState(false);
  const [ads, setAds] = useState(false);
  const [message, setMessage] = useState("");
  const [alert, setAlert] = useState("");
  // Honeypot — real users never see or fill this; bots that auto-fill every
  // input on the page do. Combined with formLoadedAt (a timing trap: humans
  // take at least a few seconds to fill the form) on the backend.
  const [honeypot, setHoneypot] = useState("");
  const [formLoadedAt] = useState(() => Date.now());

  const rowStyle = {
    margin: '1%'
  };

  const servicesStyle = {
    marginTop: '0%',
    width:"100%"
  };

  const newsletterStyle = {
      marginTop: '0%',
      width:"100%",
      padding:"13% 0"
  }

  const newsletterCardStyle = {
    backgroundColor: "#111",
    border: "1px solid #68FF00",
    borderRadius: "20px",
    boxShadow: "0 0 30px rgba(104, 255, 0, 0.15)",
    width: "100%",
    padding: "2.75rem 2rem"
  };

  const newsletterInputStyle = {
    display: "block",
    margin: "0 auto 1.5rem",
    width: "100%",
    maxWidth: "360px",
    padding: "0.85rem 1.15rem",
    borderRadius: "2rem",
    border: "1px solid #333",
    backgroundColor: "#1a1a1a",
    color: "#fff",
    fontSize: "1rem",
    outline: "none"
  };

  const newsletterButtonStyle = {
    marginTop: "1.75rem",
    padding: "0.85rem 2.75rem",
    backgroundColor: "#68FF00",
    color: "#000",
    border: "none",
    borderRadius: "2rem",
    fontWeight: 700,
    textTransform: "uppercase" as const,
    letterSpacing: "0.05em",
    fontSize: "1rem",
    cursor: "pointer"
  };

  const infoCardStyle = {
    backgroundColor: "#111",
    border: "1px solid #68FF00",
    borderRadius: "20px",
    boxShadow: "0 0 20px rgba(104, 255, 0, 0.12)",
    padding: "2rem 1.75rem",
    height: "100%"
  };

  const newsletterChipStyle = (active: boolean) => ({
    display: "inline-block",
    padding: "0.55rem 1.1rem",
    margin: "0.3rem",
    borderRadius: "2rem",
    border: "1px solid #68FF00",
    backgroundColor: active ? "#68FF00" : "transparent",
    color: active ? "#000" : "#68FF00",
    fontWeight: 600,
    fontSize: "0.85rem",
    cursor: "pointer",
    userSelect: "none" as const,
    transition: "all 0.15s ease"
  });

  const interestOptions: { key: string; label: string; active: boolean; toggle: () => void }[] = [
    { key: "beats", label: "Beats", active: beats, toggle: () => setBeats(!beats) },
    { key: "mixing", label: "Mixing", active: mixing, toggle: () => setMixing(!mixing) },
    { key: "loopsTemplates", label: "Loops & Templates", active: loopsTemplates, toggle: () => setLoopsTemplates(!loopsTemplates) },
    { key: "visuals", label: "Branding", active: visuals, toggle: () => setVisuals(!visuals) },
    { key: "web", label: "Web Development", active: web, toggle: () => setWeb(!web) },
    { key: "ads", label: "Ads", active: ads, toggle: () => setAds(!ads) }
  ];

  function handleSubmit() {
    console.log('handle submit request to subscribe')
  
    // Check if data is valid
    if (!email) {
      console.log('No e-mail address provided');
      setAlert('Please set an e-mail address~');
      return;
    }

    const dataToSend = {
      email,
      name,
      phone,
      beats,
      mixing,
      loopsTemplates,
      visuals,
      web,
      ads,
      website: honeypot,
      formLoadedAt
    };
  
    // Make a POST request using Axios
    axios.post(`${API_BASE_URL}/newsletter/subscribe`, dataToSend, {
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then(() => {
        console.log('Request successful');
        setMessage("Your e-mail has been saved!")
        setAlert(''); // Resetting alert if necessary
      })
      .catch((error) => {
        setAlert("There was an error.");
        console.error('Error: ', error);
        setMessage(''); // Resetting message if necessary
      });
  }

      return (
        <Container className="aboutContainer">
          
          <Row style={rowStyle}>
            <Col sm={2}></Col>
            <Col sm={8}>
              <h1 className="subpage-title aboutTitle">Music Production | Audio Engineering</h1>
            </Col>
            <Col sm={2}></Col>
          </Row>
          <Row style={rowStyle}>
            <Col sm={12}>
              <h5 className="subsection-title" style={{marginTop: "2%"}}>Services</h5>
              <ul>
                <li>Music Production & Audio Engineering (Recording, Mixing & Mastering, Vocal Production, Editing & Tuning)</li>
                <li>Songwriting, Production Lessons, Piano, Guitar & Voice Lessons</li>
              </ul>
            </Col>
          </Row>

         
          <Row style={rowStyle}>
            <Col sm={12} style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: "1rem", marginTop: "0.5rem" }}>
              <h5 className="subsection-title" style={{ margin: 0 }}>
                <a href={BEATSTARS_TRACKS_URL} target="_blank" rel="noopener noreferrer" style={{ color: "inherit", textDecoration: "none" }}>
                  Beats <span style={{color:"#DF0000"}}>(BUY 1 GET 1 FREE)</span>
                </a>
              </h5>
              <a href={BEATSTARS_TRACKS_URL} target="_blank" rel="noopener noreferrer" aria-label="Beats on BeatStars" title="Beats on BeatStars">
                <BeatStarsIcon size={30} />
              </a>
            </Col>
          </Row>
          <Row style={rowStyle}>
            <Col sm={12}>
            <iframe
              className="beatstars-embed"
              title="gen.wav beats on BeatStars"
              src="https://player.beatstars.com/?storeId=140652">
          </iframe>
            </Col>
          </Row>

          <Row style={rowStyle}>
            <Col sm={12}>
              <h5 className="subsection-title" style={{marginTop: "5%"}}>Deals</h5>
            </Col>
          </Row>
          <Row style={rowStyle}>
            {BEAT_DEALS.map((deal) => (
              <Col key={deal.url} xs={12} md={6} style={{ marginBottom: "1rem" }}>
                <a
                  href={deal.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    gap: "1rem",
                    height: "100%",
                    padding: "1.25rem 1.5rem",
                    background: "#111",
                    border: "1px solid #68FF00",
                    borderRadius: 16,
                    boxShadow: "0 0 24px rgba(104, 255, 0, 0.12)",
                    color: "#fff",
                    textDecoration: "none"
                  }}
                >
                  <span>
                    <span style={{ display: "block", fontSize: "1.35rem", fontWeight: 700, color: "#68FF00" }}>{deal.name}</span>
                    <span style={{ display: "block", color: "#d4d4d4", marginTop: "0.2rem" }}>{deal.detail}</span>
                    <span style={{ display: "inline-block", marginTop: "0.75rem", color: "#DF0000", fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.05em", fontSize: "0.85rem" }}>
                      Get the pack →
                    </span>
                  </span>
                  <BeatStarsIcon size={36} />
                </a>
              </Col>
            ))}
          </Row>

          <Row style={rowStyle}>
            <Col sm={12}>
              <h5 className="subsection-title" style={{marginTop: "5%"}}>Productions</h5>
            </Col>
          </Row>
            <Row style={rowStyle}>
               <Col sm={4}>
                  <iframe width="100%" height="220" src="https://www.youtube.com/embed/Y0I3k4xsKxk?si=G3fnFW6WCNacD726" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowFullScreen style={{ minWidth: 0 }}></iframe>
                </Col>
                  <Col sm={4}>
                    <iframe width="100%" height="220" src="https://www.youtube.com/embed/9zTbm_5Q8hM?si=ePdfJjQyMXwqcbvh" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowFullScreen style={{ minWidth: 0 }}></iframe>
                  </Col>
                <Col sm={4}>
                  <iframe width="100%" height="220" src="https://www.youtube.com/embed/-l30sZtFzJw?si=-tfQfbMGpLSGdXHy" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowFullScreen style={{ minWidth: 0 }}></iframe>
                </Col>
              </Row>
              <Row style={rowStyle}>
                 <Col sm={4}>
                <iframe width="100%" height="220" src="https://www.youtube.com/embed/videoseries?list=PLcGBMxEyx5p8sfg853csGDXChKZo2ZNNi" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
              </Col>
                  <Col sm={4}>
                <iframe width="100%" height="220" src="https://www.youtube.com/embed/videoseries?list=PLcGBMxEyx5p9cfbXNscaNm6tjNaOoWGBP" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowFullScreen></iframe>
              </Col>
                <Col sm={4}>
                  <iframe width="100%" height="220" src="https://www.youtube.com/embed/0qUe5yHrXME?si=9_69oglkzU8Ko0bC" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowFullScreen></iframe>
                </Col>
              </Row>
              <Row style={rowStyle}>
                 <Col sm={4}>
                  <iframe width="100%" height="220" src="https://www.youtube.com/embed/o5__bvpQ2TE?si=D_b6ni-SrcayntgQ" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowFullScreen></iframe>
                </Col>
               
                <Col sm={4}>
                  <iframe width="100%" height="220" src="https://www.youtube.com/embed/LJwhyKUX7SI?si=obJ4UiI4FysglOGY" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowFullScreen></iframe>
                </Col>
                <Col sm={4}>
                 <iframe width="100%" height="220" src="https://www.youtube.com/embed/GN2xNbORvi8?si=POjqdPrWmx33gBb6" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowFullScreen></iframe>
                </Col>
               
              </Row>
            <Row style={rowStyle}>
                <Col sm={4}>
                  <iframe width="100%" height="220" src="https://www.youtube.com/embed/W70uVdpZBxY?si=-gz8f2_oDLBXlWHW" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowFullScreen></iframe>
                </Col>
                <Col sm={4}>
                  <iframe width="100%" height="220" src="https://www.youtube.com/embed/rA59UKIzpgo?si=ycJ388eF3ULM1IxE" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowFullScreen></iframe>
                </Col>
                 <Col sm={4}>
                  
                </Col>
              </Row>

           <Row style={rowStyle}>
            <Col sm={12}>
              <h5 className="subsection-title" style={{marginTop: "5%"}}>Mixes</h5>
            </Col>
          </Row>
          <Row style={rowStyle}>
            <Col sm={4}>
              <iframe width="100%" height="220" src="https://www.youtube.com/embed/XDuqJH9VsHg" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowFullScreen></iframe>
            </Col>
            <Col sm={4}>
              <iframe width="100%" height="220" src="https://www.youtube.com/embed/VrSGomwNju0?si=4chE9-l5uA_aG-T0" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen>
              </iframe>
            </Col>
            <Col sm={4}>
              <iframe width="100%" height="220" src="https://www.youtube.com/embed/dGg3WreeDT0?si=174CwO_G6vyth7HK" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowFullScreen></iframe>
            </Col>
          </Row>
          <Row style={rowStyle}>
            <Col sm={4}>
              <iframe data-testid="embed-iframe" src="https://open.spotify.com/embed/track/6VZhwsrNbN6btKsyYMgCUc?utm_source=generator" width="100%" height="220" frameBorder="0" allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture" loading="lazy"></iframe>
            </Col>
          </Row>

            <Row style={rowStyle}>
              <Col sm={12}>
                <h5 className="subsection-title" style={{marginTop: "5%"}}>Pricing</h5>
              </Col>
            </Row>
            <Row style={{ ...rowStyle, marginBottom: "1.5rem" }}>
              <Col sm={6} style={{ marginBottom: "1.5rem", display: "flex", flexDirection: "column", gap: "1.5rem" }}>
                <div style={{ ...infoCardStyle, height: "auto" }}>
                  <h5 className="subsection-title" style={{ color: "#68FF00", marginTop: 0 }}>Recording Sessions</h5>
                  {/* Miami | Fort Lauderdale on top, House Call | Remote below, 50/50 so rows line up */}
                  <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "1rem" }}>
                  <div>
                  <h6 style={{ color: "#fff", fontWeight: 700, marginBottom: "0.4rem" }}>Miami (Red Squid Studios / Mars Miami Studios)</h6>
                  <ul style={{ marginBottom: 0, paddingLeft: "1.1rem" }}>
                    <li><a href="https://square.link/u/APfouSRh" target="_blank" rel="noopener noreferrer" className="price-link">2 Hours: <span className="price">$200</span></a></li>
                    <li><a href="https://square.link/u/oHRAj0PJ" target="_blank" rel="noopener noreferrer" className="price-link">4 Hours: <span className="price">$400</span></a></li>
                    <li><a href="https://square.link/u/AtDYoDkM" target="_blank" rel="noopener noreferrer" className="price-link">8 Hours: <span className="price">$760 (5% off)</span></a></li>
                  </ul>
                  </div>
                  <div>
                  <h6 style={{ color: "#fff", fontWeight: 700, marginBottom: "0.4rem" }}>Fort Lauderdale (Peace Kings Studios)</h6>
                  <ul style={{ marginBottom: 0, paddingLeft: "1.1rem" }}>
                    <li><a href="https://square.link/u/lx6seMHc" target="_blank" rel="noopener noreferrer" className="price-link">2 Hours: <span className="price">$150</span></a></li>
                    <li><a href="https://square.link/u/2BjcuCt1" target="_blank" rel="noopener noreferrer" className="price-link">4 Hours: <span className="price">$300</span></a></li>
                    <li><a href="https://square.link/u/YiAS1wvn" target="_blank" rel="noopener noreferrer" className="price-link">8 Hours: <span className="price">$570 (5% off)</span></a></li>
                  </ul>
                  </div>
                  <div>
                  <h6 style={{ color: "#fff", fontWeight: 700, marginBottom: "0.4rem" }}>House Call / Your Studio of Choice</h6>
                  <ul style={{ marginBottom: 0, paddingLeft: "1.1rem" }}>
                    <li><a href="https://square.link/u/SKmN3wqc" target="_blank" rel="noopener noreferrer" className="price-link">2 Hours: <span className="price">$80</span></a></li>
                    <li><a href="https://square.link/u/LuaYIdtm" target="_blank" rel="noopener noreferrer" className="price-link">4 Hours: <span className="price">$160</span></a></li>
                    <li><a href="https://square.link/u/dxfSIwmh" target="_blank" rel="noopener noreferrer" className="price-link">8 Hours: <span className="price">$300 (6% off)</span></a></li>
                  </ul>
                  </div>
                  <div>
                  <h6 style={{ color: "#fff", fontWeight: 700, marginBottom: "0.4rem" }}>Remote Recording Session</h6>
                  <ul style={{ marginBottom: 0, paddingLeft: "1.1rem" }}>
                    <li><a href="https://square.link/u/xE8xTrox" target="_blank" rel="noopener noreferrer" className="price-link">2 Hours: <span className="price">$80</span></a></li>
                    <li><a href="https://square.link/u/J4RnGhIi" target="_blank" rel="noopener noreferrer" className="price-link">4 Hours: <span className="price">$160</span></a></li>
                    <li><a href="https://square.link/u/ES7ikUh1" target="_blank" rel="noopener noreferrer" className="price-link">8 Hours: <span className="price">$300 (6% off)</span></a></li>
                  </ul>
                  </div>
                  </div>
                </div>
                <div style={{ ...infoCardStyle, height: "auto", flexGrow: 1 }}>
                  <h5 className="subsection-title" style={{ color: "#68FF00", marginTop: 0 }}>Lessons</h5>
                  <p style={{ color: "#aaa", fontSize: "0.9rem", marginBottom: "0.5rem" }}>
                    Music Production, Music Theory &amp; Composition, Arrangement, Recording &amp; Editing, Sound Design,
                    Mixing &amp; Mastering, Piano, Guitar &amp; Voice Lessons
                  </p>
                  <ul style={{ marginBottom: 0 }}>
                    <li><a href="https://square.link/u/b83sgnzY" target="_blank" rel="noopener noreferrer" className="price-link">1 Hour Lesson: <span className="price">$40</span></a></li>
                    <li><a href="https://square.link/u/hzIc6YQg" target="_blank" rel="noopener noreferrer" className="price-link">2 Hour Lesson: <span className="price">$60</span></a></li>
                  </ul>
                </div>
              </Col>
                <Col sm={6} style={{ marginBottom: "1.5rem", display: "flex", flexDirection: "column", gap: "1.5rem" }}>
                <div style={{ ...infoCardStyle, height: "auto" }}>
                  {/* Beat Licenses title + list link to the beat store (Songwriting
                      below has its own booking links, so the card itself isn't a link). */}
                  <a
                    href={BEATSTARS_TRACKS_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Beat licenses — browse beats on BeatStars"
                    style={{ display: "block", color: "inherit", textDecoration: "none" }}
                  >
                    <h5 className="subsection-title" style={{ color: "#68FF00", marginTop: 0 }}>Beat Licenses (BUY 1 GET 1 FREE)</h5>
                    <ul>
                      <li><span className="price-link">Non-Exclusive License: <span className="price">$20</span></span></li>
                      <li><span className="price-link">Unlimited Streams License: <span className="price">$100</span></span></li>
                      <li><span className="price-link">Exclusive License: <span className="price">NEGOTIABLE</span></span></li>
                    </ul>
                  </a>
                  <h5 className="subsection-title" style={{ color: "#68FF00" }}>Songwriting</h5>
                  <p style={{ color: "#aaa", fontSize: "0.9rem", marginBottom: "0.5rem" }}>
                    25% publishing for lyrics, 50% publishing for lyrics + top line melody
                  </p>
                  <ul style={{ marginBottom: 0 }}>
                    <li><a href="https://square.link/u/T79pkaWm" target="_blank" rel="noopener noreferrer" className="price-link">2 Hour Session: <span className="price">$60</span></a></li>
                    <li><a href="https://square.link/u/UorO2jUs" target="_blank" rel="noopener noreferrer" className="price-link">4 Hour Session: <span className="price">$120</span></a></li>
                  </ul>
                </div>
                <div style={{ ...infoCardStyle, height: "auto", flexGrow: 1 }}>
                  <h5 className="subsection-title" style={{ color: "#68FF00", marginTop: 0 }}>Mixing + Mastering</h5>
                  <ul style={{ marginBottom: 0 }}>
                    <li><a href="https://square.link/u/qsoscZeC" target="_blank" rel="noopener noreferrer" className="price-link">Basic Mix + Master: <span className="price">$100 (up to 10 stems)</span></a></li>
                    <li><a href="https://square.link/u/BdD9A9Pn" target="_blank" rel="noopener noreferrer" className="price-link">Premium Mix + Master: <span className="price">$200</span></a></li>
                  </ul>
                </div>
              </Col>
            </Row>

          <hr style={{backgroundColor:"white", marginTop:"5%"}}></hr>

          <Row style={{ ...rowStyle, marginTop: "6%", marginBottom: "6%" }}>
            <Col xs={12} md={6} >
              <h5 className="subsection-title" style={{marginTop: "12%"}}>Why should you hire a Producer or Engineer?</h5>
              <ul>
                <li>Prioritize your singing and songwriting</li>
                <li>Have an experienced Music Producer personally craft your sound</li>
                <li>Have a professional handle all the detailed work</li>
              </ul>
              <h4 className="mt-5">Email Us</h4>
              <a href="mailto:info@enigma-labs.com" className="text-white">info@enigma-labs.com</a>
             <div style={{marginBottom:"3%"}}></div>
            </Col>
            <Col xs={12} md={6} style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
              <div style={newsletterCardStyle}>
                <form style={{ textAlign: "center", width: "100%", maxWidth: "420px", margin: "0 auto" }}>
                  <h3 style={{ color: "#68FF00", marginBottom: "0.25rem" }}>Sign Up For Our Newsletter</h3>
                  <p style={{ color: "#aaa", fontSize: "0.9rem", marginBottom: "1.5rem" }}>
                    Beats, Freebies, and discounts. No spam.
                  </p>
                  {/* Honeypot — hidden from real users, tempting for bots that auto-fill every field */}
                  <input
                    type="text"
                    name="website"
                    value={honeypot}
                    onChange={(e) => setHoneypot(e.target.value)}
                    tabIndex={-1}
                    autoComplete="off"
                    aria-hidden="true"
                    style={{ position: "absolute", left: "-9999px", width: "1px", height: "1px", opacity: 0 }}
                  ></input>
                  <input
                    type="text"
                    name="name"
                    placeholder="Your name"
                    style={newsletterInputStyle}
                    onChange={(e) => {
                      setName(e.target.value);
                    }}
                  ></input>
                  <input
                    type="email"
                    name="e-mail"
                    placeholder="your@email.com"
                    style={newsletterInputStyle}
                    onChange={(e) => {
                      setEmail(e.target.value);
                    }}
                  ></input>
                  <input
                    type="tel"
                    name="phone"
                    placeholder="Phone number"
                    style={newsletterInputStyle}
                    onChange={(e) => {
                      setPhone(e.target.value);
                    }}
                  ></input>
                  <label style={{ display: "block", color: "#d4d4d4", marginBottom: "0.5rem" }}>
                    What are you interested in?
                  </label>
                  <div style={{ textAlign: "center" }}>
                    {interestOptions.map((option) => (
                      <span
                        key={option.key}
                        role="checkbox"
                        aria-checked={option.active}
                        tabIndex={0}
                        style={newsletterChipStyle(option.active)}
                        onClick={option.toggle}
                        onKeyDown={(e) => {
                          if (e.key === "Enter" || e.key === " ") {
                            e.preventDefault();
                            option.toggle();
                          }
                        }}
                      >
                        {option.label}
                      </span>
                    ))}
                  </div>
                  <button
                    onClick={(e) => {
                      e.preventDefault();
                      handleSubmit();
                    }}
                    style={newsletterButtonStyle}
                    type="submit"
                  >
                    Submit
                  </button>
                  {message && <Alert style={{ marginTop: "1.5rem", backgroundColor: "#111", borderColor: "#68FF00", color: "#68FF00" }}>{message.toString()}</Alert>}
                  {alert && <Alert style={{ marginTop: "1.5rem", backgroundColor: "#2a0000", borderColor: "#ff4d4d", color: "#ff9d9d" }}>{alert.toString()}</Alert>}
                </form>
              </div>
            </Col>
          </Row>

          
        </Container>
        
      );
  
};



export default Music;
//<img src={image1} style={{width: '100%', height: '80%'}}/>
